import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

let payments = {
  state,
  mutations,
  actions,
  getters
}

export default payments



// WEBPACK FOOTER //
// ./src/store/request/index.js